import React, { useState } from 'react'

import Modal from '@/pages/form/Modal'
import Button from '@components/buttons/Button'
import modalArrow from '@assets/form/modal-arrow.png'
import warningIcon from '@assets/form/warning.svg'

import './InvitationResultModal.css'

export interface InvitationResult {
	/** Link the buyers follow to fill in the form. */
	link: string
	/** Buyer addresses the link reached. */
	emailedTo: string[]
	/** Buyer addresses the link could not be sent to. */
	emailFailures: string[]
}

interface InvitationResultModalProps {
	title: string
	result: InvitationResult
	closeLabel: string
	onClose: () => void
}

// InvitationResultModal reports what became of the buyers' invitation, whether
// it was just created or resent. The link is always offered: it is the way out
// when the email did not go through.
function InvitationResultModal({ title, result, closeLabel, onClose }: InvitationResultModalProps) {
	const [linkCopied, setLinkCopied] = useState(false)

	const copyLink = async () => {
		try {
			await navigator.clipboard.writeText(result.link)
			setLinkCopied(true)
		} catch (error) {
			console.error('Error copying the form link: ', error)
		}
	}

	const sent = result.emailedTo.length > 0
	const failed = result.emailFailures.length > 0

	return (
		<Modal>
			<div className='modalBody'>
				<h1>{title}</h1>
				{/* The illustration reports the outcome at a glance: the same paper
				    plane the buyer sees on submit, or a warning when nothing flew. */}
				{sent ? (
					<img data-testid='invitationSent' src={modalArrow} alt='' />
				) : (
					<img
						data-testid='invitationFailed'
						className='invitationWarningIcon'
						src={warningIcon}
						alt=''
					/>
				)}
				{sent && (
					<p>
						Le lien du formulaire a été envoyé par email à :
						<br />
						<strong>{result.emailedTo.join(', ')}</strong>
					</p>
				)}
				{failed && (
					<p className='invitationWarning'>
						Le lien n'a pas pu être envoyé à <strong>{result.emailFailures.join(', ')}</strong>.
						Copiez-le ci-dessous pour le transmettre vous-même.
					</p>
				)}
				{!sent && !failed && (
					<p className='invitationWarning'>
						Aucune adresse email n'a été renseignée. Copiez le lien ci-dessous pour le
						transmettre aux acquéreurs.
					</p>
				)}
				<div className='invitationLink'>
					<span className='invitationLinkValue'>{result.link}</span>
					<Button onClick={copyLink}>{linkCopied ? 'Lien copié' : 'Copier le lien'}</Button>
				</div>
				<div className='modalActions'>
					<Button onClick={onClose}>{closeLabel}</Button>
				</div>
			</div>
		</Modal>
	)
}

export default InvitationResultModal
